import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {setDoGenerateReportClick, setLoading} from "../rx/orders/orderExportAction";
import {FormattedMessage} from "react-intl";
import {Button, Icon, Spin} from "antd";
import React from "react";
import {doExportOrder} from "../api/api";
import {setTime} from "../rx/bulkfxupdate";
import {displayError} from "../common/notifications";

function ExportOrderButton (props) {

    // const [loadingBtn,setLoadingBtn] = useState(false)

    const onClick =async (props)  => {
        props.setLoading(true);
        // if(props.reportType=="17") {
        //     doExportOrder(props.from,props.to, props.reportType,props.currencies).then(response => {
        //         const a = document.createElement('a');
        //         a.href = response.link;
        //         a.download = response.name;
        //         a.click();
        //
        //     }).catch(e => {
        //             displayError(e.message);
        //         }
        //     )
        // }else {
            let response = await props.setGenerateReportClick(props.from, props.to, props.reportType, props.currencies);
        // }
        setTimeout(()=>{
            props.setLoading(false);
        },2000)

        props.refreshPage();
    }

    if(props.loading) {
        const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return (<Spin indicator={antIcon}/>)
    }

    return (
    <Button type="primary"
            loading={props.loading}
            onClick={() => onClick(props)}
            style={{minHeight: '40px'}}>
        <FormattedMessage id="app.table.orderstabletoolbar.generate.report"/>
    </Button>
    );
}

    const mapStateToProps = (state) => {
    return {
        loading:state.orderExport.loading,
        doExportClick:false,
        error: state.orderExport.error
        // success: state.exportOrderData.success
    }
    };

    const mapDispatchToProps = dispatch =>{
        return {
            setLoading: (val) => dispatch(setLoading(val)),
            // setDoExportClick: (from,to, reportType,currencies) => dispatch(setDoExportClick(from,to, reportType,currencies))
            setGenerateReportClick: (from,to, reportType,currencies) => dispatch(setDoGenerateReportClick(from,to, reportType,currencies))
        }
    }
export default connect (
    mapStateToProps,
    mapDispatchToProps
) (withRouter(ExportOrderButton))